import React from "react";
import PropTypes from "prop-types";
import RangeOptionSelect from "../../../elements/range-option-select";
import ToolSectionTabs from "./ToolSectionTabs";
import RangeSlider from "../../../elements/range-slider";
import CheckboxTool from "./CheckboxTool";

const ToolSectionType = ({
  match,
  lang,
  type,
  value,
  defaultOption,
  defaultLabel,
  options,
  settings,
  unit,
  serverResponseStatus,
  serverResponseErrorMsg,
  isLoading,
  isSpecialFormat,
  onClick
}) => {
  switch (type) {
    case "tabs":
      return (
        <ToolSectionTabs
          match={match}
          defaultLabel={defaultLabel}
          options={options}
          serverResponseStatus={serverResponseStatus}
          serverResponseErrorMsg={serverResponseErrorMsg}
          isLoading={isLoading}
          lang={lang}
          isSpecialFormat={isSpecialFormat}
        />
      );
    case "select":
      return (
        <RangeOptionSelect
          defaultOption={defaultOption}
          options={options}
          unit={unit}
          onClick={onClick}
          lang={lang}
        />
      );
    case "slider":
      return <RangeSlider {...settings} lang={lang} isSpecialFormat={isSpecialFormat} />;
    case "checkbox":
      return <CheckboxTool options={options} lang={lang}/>;
    case "fixed":
      return <p className="fixed-value">{value}</p>;
    default:
      return null;
  }
};

ToolSectionType.propTypes = {
  type: PropTypes.string,
  value: PropTypes.any,
  defaultOption: PropTypes.object,
  options: PropTypes.array,
  settings: PropTypes.object,
  unit: PropTypes.string,
  onClick: PropTypes.func
};

export default ToolSectionType;
